export default {
  primary: {
    color: "background",
    bg: "primary",
    borderRadius: "default",
    fontWeight: 500,
    "&:hover": {
      bg: "muted",
      color: "dark",
      cursor: "pointer",
    },
  },
  light: {
    variant: "buttons.primary",
    bg: "background",
    color: "primary",
  },
  menu: {
    variant: "buttons.light",
    bg: "background",
    color: "text",
  },
}
